import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { JsonData } from "./export-to-excel.model";

@Injectable({
  providedIn: "root",
})
export class ExportToExcelService {
  constructor(private http: HttpClient) {}

  getEtePanelData(cut: string, ticker: string): Observable<any> {
    const params = [];
    params.push(`pg=IS`);
    params.push(`cut=NMV`);
    params.push(`ticker=${ticker}`);
    params.push(
      `from_nmv=${["nmv", "sch", "std"].includes(cut.toLocaleLowerCase())}`,
    );
    params.push(`is_calendar=true`);
    params.push(`format=json`);

    return this.http.get(
      `${window.apiUrl}/api/get_panel_data_for_export?${params.join("&")}`,
    );
  }

  getEteTree(ticker: string): Observable<any> {
    return this.http.get(`${window.apiUrl}/api/etetreedata/?&ticker=${ticker}`);
  }

  // https://uat-appx1.visiblealpha.com/api/exportexcelhistory/
  saveExportExcelHistory(jsonData: JsonData, ticker: string): Observable<any> {
    const params = {
      company: ticker,
      cut: null,
      jsonData: jsonData,
    };

    return this.http.post(`${window.apiUrl}/api/exportexcelhistory/`, params);
  }

  // https://uat-appx1.visiblealpha.com/api/exportexcelhistory/?companyid=AAL&format=json
  getExportExcelPrevHistory(ticker: string, format = "json"): Observable<any> {
    return this.http.get(
      `${window.apiUrl}/api/exportexcelhistory/?companyid=${ticker}&format=${format}`,
    );
  }

  // https://uat-appx1.visiblealpha.com/api/prepare_exporttoexcel_object/?&ticker=AAL&trackerid=492594
  prepareExport(
    ticker: string,
    trackerid: number,
    currency = "",
  ): Observable<any> {
    let url = `${window.apiUrl}/api/prepare_exporttoexcel_object/?&ticker=${ticker}&trackerid=${trackerid}`;
    url += currency ? `&currency=${currency}` : "";
    return this.http.get(url);
  }

  getNextExportStatus(ticker: string, cut: string, pg: string) {
    return this.http.get(
      `${window.apiUrl}/api/get_next_export_status?ticker=${ticker}&pg=${pg}&cut=${cut}`,
    );
  }
}
